import { useMutation, useQuery } from "@tanstack/react-query";
import { OrganizationService } from "../../services"
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants";
import Noti from "../../view/components/general/noti";
import { handleResponse, queryClient } from "./setup";
import {IhioPrescriptionFillingsService} from "../../services/requests/visit/ihioPrescriptionFilling";


const useWrittenPrescriptionAdmission = () => {
    return useMutation({
        mutationFn: IhioPrescriptionFillingsService.writtenPrescriptionAdmission,
    })
}

const useWrittenPrescriptionPrintOrder = () => {
    const navigate = useNavigate();
    return useMutation({
        mutationFn: IhioPrescriptionFillingsService.writtenPrescriptionPrintOrder,
        onSuccess: (data) => {
            handleResponse({
                data,
                onSuccess: () => {
                    Noti("success", data?.data?.msg)
                    // navigate(ROUTES.ORGANIZATION.PATH);
                }
            })
        },
    })
}

const useGetIhioDeliverCheckCode = () => {
    const navigate = useNavigate();
    return useMutation({
        mutationFn: IhioPrescriptionFillingsService.getIhioDeliverCheckCode,
        onSuccess: (data) => {
            handleResponse({
                data,
                onSuccess: () => {
                    Noti("success", data?.data?.msg)
                    // navigate(ROUTES.ORGANIZATION.PATH);
                }
            })
        },
    })
}

const useSendIhioPrescriptionFilling = () => {
    const navigate = useNavigate();
    return useMutation({
        mutationFn: IhioPrescriptionFillingsService.sendIhioPrescriptionFilling,
        onSuccess: (data) => {
            handleResponse({
                data,
                onSuccess: () => {
                    Noti("success", data?.data?.msg)
                    // navigate(ROUTES.ORGANIZATION.PATH);
                }
            })
        },
    })
}

const useGetFilledPrescriptionPrint = () => {
    const navigate = useNavigate();
    return useMutation({
        mutationFn: IhioPrescriptionFillingsService.getFilledPrescriptionPrint,
        onSuccess: (data) => {
            handleResponse({
                data,
                onSuccess: () => {
                    Noti("success", data?.data?.msg)
                }
            })
        },
    })
}

const useGetDeliveredPrescription = () => {
    const navigate = useNavigate();
    return useMutation({
        mutationFn: IhioPrescriptionFillingsService.getDeliveredPrescription,
        onSuccess: (data) => {
            handleResponse({
                data,
                onSuccess: () => {
                    // Noti("success", data?.data?.msg)
                    // navigate(ROUTES.ORGANIZATION.PATH);
                }
            })
        },
    })
}

const useGetOrderedPrescription = () => {
    const navigate = useNavigate();
    return useMutation({
        mutationFn: IhioPrescriptionFillingsService.getOrderedPrescription,
        onSuccess: (data) => {
            handleResponse({
                data,
                onSuccess: () => {
                    // Noti("success", data?.data?.msg)
                    // navigate(ROUTES.ORGANIZATION.PATH);
                }
            })
        },
    })
}

const useGetFilledPrescriptionDeliverList = (params: any, modalName?: boolean) => {
    return useQuery({
        queryKey: ["getFilledPrescriptionDeliverList", params],
        queryFn: ({ queryKey }: any) => {
            const [_, params] = queryKey;
            return IhioPrescriptionFillingsService.getFilledPrescriptionDeliverList(params);
        },
        enabled: modalName ?? true
    });
}

const useGetHistoryPrescriptionOrderList = (params: any, modalName?: boolean) => {
    return useQuery({
        queryKey: ["getHistoryPrescriptionOrderList", params],
        queryFn: ({ queryKey }: any) => {
            const [_, params] = queryKey;
            return IhioPrescriptionFillingsService.getHistoryPrescriptionOrderList(params);
        },
        enabled: modalName ?? true
    });
}

const useGetIhioBillCheck = (modalName?: boolean) => {
    return useQuery({
        queryKey: ["getIhioBillCheck", modalName],
        queryFn: ({ queryKey }: any) => {
            const [_, params] = queryKey;
            return IhioPrescriptionFillingsService.getIhioBillCheck();
        },
        enabled: modalName ?? true
    });
}

const useGetIhioBillList = () => {
    const navigate = useNavigate();
    return useMutation({
        mutationFn: IhioPrescriptionFillingsService.getIhioBillList,
        onSuccess: (data) => {
            handleResponse({
                data,
                onSuccess: () => {
                    // Noti("success", data?.data?.msg)
                    // navigate(ROUTES.ORGANIZATION.PATH);
                }
            })
        },
    })
}

const useGetPrescriptionReferralList = (params: any, modalName?: boolean) => {
    return useQuery({
        queryKey: ["getPrescriptionReferralList", params],
        queryFn: ({ queryKey }: any) => {
            const [_, params] = queryKey;
            return IhioPrescriptionFillingsService.getPrescriptionReferralList(params);
        },
        enabled: modalName ?? true
    });
}

const useGetPrescriptionReferralInfo = () => {
    const navigate = useNavigate();
    return useMutation({
        mutationFn: IhioPrescriptionFillingsService.getPrescriptionReferralInfo,
        onSuccess: (data) => {
            handleResponse({
                data,
                onSuccess: () => {
                    // Noti("success", data?.data?.msg)
                    // navigate(ROUTES.ORGANIZATION.PATH);
                }
            })
        },
    })
}

export {
    useWrittenPrescriptionAdmission,
    useWrittenPrescriptionPrintOrder,
    useGetIhioDeliverCheckCode,
    useSendIhioPrescriptionFilling,
    useGetFilledPrescriptionPrint,
    useGetDeliveredPrescription,
    useGetOrderedPrescription,
    useGetFilledPrescriptionDeliverList,
    useGetHistoryPrescriptionOrderList,
    useGetIhioBillCheck,
    useGetIhioBillList,
    useGetPrescriptionReferralList,
    useGetPrescriptionReferralInfo,
}
